import { all } from "@redux-saga/core/effects";
import { branchesEntriesSagas } from "modules/Branches/services/Branches/sagas";

export function* branchesSaga() {
    yield all([
        branchesEntriesSagas()
    ]);
}
